const COLUMNS = [
  {
    title: '图文深扒',
    links: ['人物深扒', '品牌与机构', '行业事件', '声明拆解', '实锤复盘']
  },
  {
    title: '帖子图解',
    links: ['事件时间轴图解', '聊天记录图解', '数据还原图解', '话术拆解图解']
  },
  {
    title: '长文连载',
    links: ['《背靠背的一年》', '「停更的半个月」', '撤投连锁事件', '连载目录']
  },
  {
    title: '关于本站',
    links: ['内容说明', '投稿与线索', '争议澄清', '转载授权', '联系编辑']
  }
];

export default function Footer() {
  return (
    <footer className="bg-espresso text-paper2/80">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center bg-verm text-paper2">
                <i className="ri-shield-flash-line text-xl" />
              </span>
              <span className="font-display text-xl font-black tracking-wide text-paper2">最全黑料</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-paper2/60">
              图文区持续更新：深扒帖配图解细节，长文还原事件经过。给想慢慢看细节、不想只看标题就划走的你。
            </p>
            <div className="mt-4 flex gap-2 text-xs text-paper2/70">
              {['图文', '图解', '长文'].map((t) => (
                <span key={t} className="rounded-full border border-paper2/20 px-2 py-0.5">{t}</span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-4 lg:col-span-4">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="mb-3 text-sm font-bold text-paper2">{col.title}</h4>
                <ul className="space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="text-sm text-paper2/60 hover:text-gold-soft">{l}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* 内容声明条 */}
        <div className="mt-10 rounded-md border border-paper2/15 bg-paper2/5 p-4 text-[13px] leading-relaxed text-paper2/55">
          <p className="flex items-center gap-2">
            <i className="ri-file-warning-line text-gold" />
            <span className="font-semibold text-paper2/75">内容声明：</span>
          </p>
          <p className="mt-1.5">
            本站图文均为对公开网络信息、公开报道与用户来稿的整理、复述与串联，用于信息梳理与事件还原，不代表本站立场，不构成对任何个人、企业或机构的定性判断。
            涉事各方如对收录内容有异议，欢迎凭事实与证据联系编辑，我们将依约核实、打码或按需下架相关帖子。
          </p>
        </div>

        {/* 版权条 */}
        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-paper2/15 pt-6 text-xs text-paper2/45 sm:flex-row">
          <p>© 2026 最全黑料 · 图文 / 图解 / 长文 深扒内容站</p>
          <div className="flex flex-wrap items-center gap-4">
            {['使用条款', '隐私说明', '内容下架通道'].map((l) => (
              <a key={l} href="#top" className="hover:text-gold-soft">{l}</a>
            ))}
            <span className="flex items-center gap-1 text-paper2/60">
              <i className="ri-server-line" /> 静态演示 · 无后台接入
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}